import { UserInfoFragment } from '../../Components/ProductFruits/ProductFruits.generated'
import mapEnquiryToPFUser from './DataMapping/mapEnquiryToPFUser'
import triggerUserSetEvent from './Helpers/triggerUserSetEvent'

// Product Fruits script loaded by Google Tag Manager when user-set event fired
const setProductFruitsUserFromEnquiry = (enquiry: UserInfoFragment): void => {
  window.dataLayer?.push({ productFruitsUser: mapEnquiryToPFUser(enquiry) })
  triggerUserSetEvent()
}

export default setProductFruitsUserFromEnquiry
